import { IInitialState } from './interfaces/state';
import produce from 'immer';
import { SET_DEFAULT_STATE } from './constants';
import { TariffAction } from './actions';

/**
 * Initial state
 */
export const initialState: IInitialState = {
    salesChannel: null,
    subscriptionId: null,
    gigakombi: false,
    gigakombiToken: null,
};

/**
 * Hardware detail reducer
 * @param state
 * @param action
 */
const tariffReducer = (state: IInitialState = initialState, action: TariffAction) =>
    produce(state, (draft: IInitialState) => {
        switch (action.type) {
            case SET_DEFAULT_STATE:
                draft.salesChannel = action.salesChannel;
                draft.subscriptionId = action.subscriptionId;
                draft.gigakombi = action.gigakombi;
                draft.gigakombiToken = action.gigakombiToken;
                break;
        }
    });

export default tariffReducer;
